import React from "react";
import env from "../../config/env";
import { GITLAB_ISSUES_STATE } from "../../constants/gitlab";
import IssueMetaTags from "./IssueMetaTags";

const IssueTitleCell = ({ record }) => {
  const title =
    record.title ||
    (record.description ? `${record.description.slice(0, 100)}...` : "");

  return (
    <div className="issue-title-cell">
      <a
        target="_blank"
        rel="noopener noreferrer"
        className="issue-project-link"
        href={`${env.gitlabBaseUrl}/${record.projectName}/-/issues?sort=updated_desc&state=${GITLAB_ISSUES_STATE.OPENED}`}
      >
        {record.projectName}
      </a>
      <div className="issue-title-row">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={record.webUrl}
          className="issue-ref-link"
        >
          <span className="issue-ref">{record.reference}</span>
        </a>
        <span className="issue-title">{title}</span>
      </div>
      <IssueMetaTags labels={record.labels} milestone={record.milestone} />
    </div>
  );
};

export default IssueTitleCell;
